import * as React from "react";
import { SettingsCard } from "../SettingsCard";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { useVersion } from "@/hooks/queries/useSystemInfo";
import { useThemeMode } from "@/theme/ThemeModeContext";

interface VersionPayload {
  data: { application_version: string; environment: string };
}

/** Reuses Sprint 3.1's `useThemeMode` (frontend-only state) and `useVersion` hook - presentation only, no editing. */
export function SettingsSection(): React.JSX.Element {
  const { mode } = useThemeMode();
  const versionQuery = useVersion();

  return (
    <QueryStateBoundary query={versionQuery}>
      {(payload) => {
        const version = payload as unknown as VersionPayload;
        return (
          <SettingsCard
            theme={mode}
            environment={version.data?.environment}
            applicationVersion={version.data?.application_version}
          />
        );
      }}
    </QueryStateBoundary>
  );
}
